import React, { useContext, useState } from "react";
import { Navbar, Container, Form, InputGroup, Button } from "react-bootstrap";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import AppsIcon from "@mui/icons-material/Apps";
import SettingsIcon from "@mui/icons-material/Settings";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { useDefaultContext } from "./context/defaultcontext";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import { Link } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import Sidebar from "../pages/Sidebar";
import { Dropdown, Row, Col } from "react-bootstrap";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { useRef, useEffect } from "react";
import {
  FiUser,
  FiSettings,
  FiArrowUpCircle,
  FiHelpCircle,
  FiLogOut,
} from "react-icons/fi";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import NotesIcon from "@mui/icons-material/Notes";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import navbar from "../assets/css/navbar.css";
import { FiCalendar } from "react-icons/fi";
import {
  FiUsers,
  FiBriefcase,
  FiTarget,
  FiUserPlus,
  FiGitBranch,
  FiActivity,
  FiArrowRight,
  FiGrid,
} from "react-icons/fi";

const TopNavbar = () => {
  const { sidebarToogle, setSidebarToogle } = useDefaultContext();
  const [show, setShow] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const crmItems = [
    { label: "Contacts", icon: <FiUsers />, path: "/contact-list" },
    { label: "Companies", icon: <FiBriefcase />, path: "/companies-list" },
    { label: "Deals", icon: <FiTarget />, path: "/deals-list" },
    { label: "Leads", icon: <FiUserPlus />, path: "/leads-list" },
    { label: "Pipeline", icon: <FiGitBranch />, path: "/pipeline" },
    { label: "Activities", icon: <FiActivity />, path: "/activity" },
  ];

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const menuItems = [
    {
      name: "Calendar",
      path: "/calendar-page",
      icon: <CalendarMonthIcon fontSize="small" />,
    },
    // { name: "To Do", path: "/todo", icon: <CheckCircleOutlineIcon fontSize="small" /> },
    {
      name: "Notes",
      path: "/notes-page",
      icon: <NotesIcon fontSize="small" />,
    },
    // { name: "File Manager", path: "/files", icon: <FolderOpenIcon fontSize="small" /> },
    {
      name: "Kanban",
      path: "/kanban-page",
      icon: <ViewKanbanIcon fontSize="small" />,
    },
    {
      name: "Invoices",
      path: "/invoices-page",
      icon: <ReceiptLongIcon fontSize="small" />,
    },
  ];
  return (
    <Navbar bg="white" className="border-bottom" style={{ zIndex: 1100 }}>
      <Offcanvas
        show={show}
        onHide={handleClose}
        style={{
          width: "fit-content",
          maxWidth: "none",
          top: "0px", // 👈 pushes below navbar
          height: "calc(100%)",
          borderTop: "none",
        }}
        backdrop={false}
      >
        <Sidebar />
      </Offcanvas>
      <Container fluid>
        <div className="d-flex align-items-center w-100">
          <div className="d-lg-none" onClick={() => setShow(!show)}>
            <MenuOpenIcon sx={{ color: "#f26522", fontSize: 28 }} />
          </div>
          <div className="d-none d-lg-flex align-items-center gap-2 me-auto">
            <Button
              variant="outline-dark border-0 p-1 d-flex align-items-center"
              onClick={() => setSidebarToogle(!sidebarToogle)}
            >
              {sidebarToogle ? (
                <FirstPageIcon fontSize="small" />
              ) : (
                <LastPageIcon fontSize="small" />
              )}
            </Button>

            <InputGroup>
              <Form.Control placeholder="Search in HRMS" />
              <InputGroup.Text>CTRL + /</InputGroup.Text>
            </InputGroup>

            <Dropdown>
              <Dropdown.Toggle
                variant="light"
                className="crm-toggle border-0 shadow-none"
              >
                <FiGrid size={18} />
              </Dropdown.Toggle>

              <Dropdown.Menu className="crm-dropdown  p-3">
                <h6 className="fw-bold mb-3 crm-title">CRM</h6>

                <div className="crm-grid">
                  {crmItems.map((item, index) => (
                    <Link
                      to={item.path}
                      key={index}
                      className="menu-item text-decoration-none"
                    >
                      <div key={index} className="crm-card">
                        <div className="d-flex align-items-center gap-2">
                          <span className="crm-icon">{item.icon}</span>
                          <span className="crm-text">{item.label}</span>
                        </div>

                        <FiArrowRight className="crm-arrow" />
                      </div>
                    </Link>
                  ))}
                </div>
              </Dropdown.Menu>
            </Dropdown>

            <Link to="/settings-page">
              <Button variant="outline-dark border-0 p-1 d-flex align-items-center">
                <SettingsIcon />
              </Button>
            </Link>
          </div>
          <Link to="/" className="d-block d-lg-none mx-auto">
            <div className="text-center">
              <img src="/assets/img/logo-1.svg" height="35" />
            </div>
          </Link>
          {/* RIGHT */}
          <Dropdown align="end" className="d-lg-none">
            <Dropdown.Toggle
              as="div"
              className="border-0 bg-transparent"
              style={{ cursor: "pointer" }}
            >
              <MoreVertIcon sx={{ color: "#f26522", fontSize: 28 }} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item>My Profile</Dropdown.Item>
              <Dropdown.Item>Settings</Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item>Logout</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <div className="d-none d-lg-flex align-items-center gap-3 ms-auto">
            <Button variant="outline-dark border-0 p-1 d-flex align-items-center">
              <FullscreenIcon />
            </Button>

            <div className="position-relative" ref={dropdownRef}>
              {/* Trigger Button */}
              <Button
                variant="light"
                className="border-0 p-1 d-flex align-items-center"
                onClick={() => setOpen(!open)}
              >
                <AppsIcon />
              </Button>

              {/* Dropdown */}
              {open && (
                <div className="apps-dropdown shadow">
                  <h6 className="dropdown-title">Applications</h6>

                  {menuItems.map((item, index) => (
                    <Link
                      to={item.path}
                      key={index}
                      className="menu-item  text-decoration-none"
                    >
                      <div key={index} className="dropdown-item-custom">
                        <div className="icon-box">{item.icon}</div>
                        <span className="text-dark">{item.name}</span>
                      </div>
                    </Link>
                  ))}
                </div>
              )}

              {/* Styles */}
              <style jsx>{`
                .apps-dropdown {
                  position: absolute;
                  top: 45px;
                  right: 0;
                  width: 260px;
                  background: #fff;
                  border-radius: 12px;
                  padding: 15px;
                  z-index: 1000;
                }

                .dropdown-title {
                  font-weight: 600;
                  margin-bottom: 12px;
                  color: #2d3748;
                }

                .dropdown-item-custom {
                  display: flex;
                  align-items: center;
                  gap: 12px;
                  padding: 8px;
                  border-radius: 8px;
                  cursor: pointer;
                  transition: 0.2s;
                }

                .dropdown-item-custom:hover {
                  background: #f5f6f8;
                }

                .icon-box {
                  width: 36px;
                  height: 36px;
                  background: #f1f3f5;
                  border-radius: 8px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: #4a5568;
                }

                /* Mobile Responsive */
                @media (max-width: 576px) {
                  .apps-dropdown {
                    width: 100%;
                    right: 0;
                    left: 0;
                    margin: auto;
                  }
                }
              `}</style>
            </div>
            <Link to="/chats-page">
              <Button
                variant="outline-dark border-0 p-1 d-flex align-items-center"
                className="position-relative"
              >
                <ChatBubbleOutlineIcon />
                <span className="position-absolute top-0 start-100 translate-middle p-1 bg-success border border-light rounded-circle"></span>
              </Button>
            </Link>

            <Link to="/emails-page">
              <Button variant="outline-dark border-0 p-1 d-flex align-items-center">
                <MailOutlineIcon />
              </Button>
            </Link>

            <Dropdown align="end">
              <Dropdown.Toggle className="notif-toggle border-0 bg-transparent p-1 position-relative">
                <NotificationsNoneIcon className="text-dark" />

                {/* Red dot */}
                <span className="notif-dot"></span>
              </Dropdown.Toggle>

              <Dropdown.Menu className="notif-dropdown mt-2 p-0">
                {/* Header */}
                <div className="notif-header d-flex justify-content-between align-items-center p-3">
                  <h6 className="mb-0 fw-bold">Notifications (2)</h6>

                  <div className="d-flex align-items-center gap-3">
                    <span className="mark-read">Mark all as read</span>

                    <span className="d-flex align-items-center gap-1 text-muted small">
                      <FiCalendar /> Today
                    </span>
                  </div>
                </div>

                <div className="divider" />

                {/* Scroll area */}
                <div className="notif-body">
                  {/* Item 1 */}
                  <div className="notif-item">
                    <img src="/assets/img/profiles/avatar-01.jpg" alt="" />
                    <div>
                      <p>
                        <strong>Shawn</strong> performance in Math is below the
                        threshold.
                      </p>
                      <span className="time">Just Now</span>
                    </div>
                  </div>

                  {/* Item 2 */}
                  <div className="notif-item">
                    <img src="/assets/img/profiles/avatar-02.jpg" alt="" />
                    <div>
                      <p>
                        <strong>Sylvia</strong> added appointment on 02:00 PM
                      </p>
                      <span className="time">10 mins ago</span>

                      <div className="notif-actions">
                        <button className="btn-deny">Deny</button>
                        <button className="btn-approve">Approve</button>
                      </div>
                    </div>
                  </div>

                  {/* Item 3 */}
                  <div className="notif-item">
                    <img src="/assets/img/profiles/avatar-03.jpg" alt="" />
                    <div>
                      <p>
                        New student record <strong>George</strong> is created by{" "}
                        <strong>Teressa</strong>
                      </p>
                      <span className="time">2 hrs ago</span>
                    </div>
                  </div>
                </div>

                <div className="divider" />

                {/* Footer */}
                <div className="notif-footer d-flex justify-content-between align-items-center gap-3 p-3">
                  <button className="btn-cancel w-50">Cancel</button>

                  <Link to="/activity" className="text-decoration-none w-50">
                    <button className="btn-view w-100">View All</button>
                  </Link>
                </div>
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown align="end">
              {/* Toggle */}
              <Dropdown.Toggle className="profile-toggle border-0 bg-transparent p-0">
                <img
                  src="/assets/img/profiles/avatar-12-1.jpg"
                  alt="profile"
                  className="rounded-circle"
                  width="35"
                  height="35"
                />
              </Dropdown.Toggle>

              {/* Dropdown */}
              <Dropdown.Menu className="profile-dropdown p-0 me-4">
                {/* Header */}
                <div className="profile-header d-flex align-items-center gap-3 p-3">
                  <img
                    src="/assets/img/profiles/avatar-12-1.jpg"
                    alt="profile"
                    className="rounded-circle"
                    width="45"
                    height="45"
                  />
                  <div>
                    <div className="profile-name">Kevin Larry</div>
                    <div className="profile-email">[email protected]</div>
                  </div>
                </div>

                <div className="divider" />

                {/* Menu Items */}

                <Link to="/profile" className="text-decoration-none text-dark">
                  <div className="profile-item">
                    <FiUser /> <span>My Profile</span>
                  </div>
                </Link>

                <Link
                  to="/settings"
                  className="text-decoration-none text-dark"
                >
                  <div className="profile-item">
                    <FiSettings /> <span>Settings</span>
                  </div>
                </Link>

                <Link
                  to="/settings"
                  className="text-decoration-none text-dark"
                >
                  <div className="profile-item">
                    <FiArrowUpCircle /> <span>My Account</span>
                  </div>
                </Link>
                {/* 
        <div className="profile-item">
          <FiHelpCircle /> <span>Knowledge Base</span>
        </div> */}

                <div className="divider" />
                <Link className="text-decoration-none" to="/login">
                  <div className="profile-item logout">
                    <FiLogOut /> <span>Logout</span>
                  </div>
                </Link>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </Container>
    </Navbar>
  );
};

export default TopNavbar;
